<template>
  <base-form :can-back="canBack" :wide="true" :disabled="disabled">
    <slot name="search-form" />
    <template #submit-button>
      <search-button class="px-4" />
      <reset-button />
    </template>
    <template #content>
      <div class="mt-5">
        <slot name="table" />
      </div>
    </template>
  </base-form>
</template>

<script>
import BaseForm from '@/views/templates/forms/BaseForm'
import SearchButton from '@/views/molecules/buttons/SearchButton'
import ResetButton from '@/views/molecules/buttons/ResetButton'

export default {
  name: "ListForm",
  components: {
    BaseForm,
    SearchButton,
    ResetButton,
  },
  props: {
    canBack: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
